import createClient from "openapi-fetch"
import type { paths } from "./api.types"

// In dev, __API_URL__ is undefined and requests go same-origin through the Bun
// proxy. In prod, build.ts injects the cross-origin API base (or "" for same
// origin). credentials: "include" sends the auth cookie on every request.
const baseUrl = typeof __API_URL__ === "string" && __API_URL__ !== "" ? __API_URL__ : "/"

export const apiClient = createClient<paths>({
  baseUrl,
  credentials: "include",
})
